import { Drawer } from "@components/v2";
import {
  type MetricsExplorerChartState,
  type MetricsExplorerFilters,
  type TileDescriptor,
} from "@features/metrics-explorer/types";
import {
  type DateRangeChoiceV4,
  type FixedDateInterval,
} from "@north-beam/nb-common";

import { SalesMetricsExplorerProvider } from "./sales-metrics-explorer-provider";

interface Props {
  isOpen: boolean;
  tiles: TileDescriptor[];
  filters: Omit<MetricsExplorerFilters, "dateRange" | "dateRangeInterval"> & {
    dateRange: DateRangeChoiceV4 | FixedDateInterval;
  };
  chartState: MetricsExplorerChartState;
  onClose: () => void;
}

export const MetricsExplorerDrawer = ({
  isOpen,
  tiles,
  filters,
  chartState,
  onClose,
}: Props) => {
  return (
    <Drawer isOpen={isOpen} onClose={onClose}>
      <SalesMetricsExplorerProvider
        tiles={tiles}
        filters={filters}
        chartState={chartState}
        onClose={onClose}
      />
    </Drawer>
  );
};
